export default __webpack_public_path__ + "static/media/referral-reward-vi.ce73ea47.svg";